import React, { useEffect, useMemo, useState } from "react";
import { OTPTimer } from "../components/OTPTimer";
import MaskedInput from "react-text-mask";

const OtpPopup = (props) => {
  const { initialMinute = 3, initialSeconds = 0, isSubmitting = false } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [IsshowPass, setIsShow] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otpValue, setOtpValue] = useState("");

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds, minutes]);

  useEffect(() => {
    setMobile(props.mobile || "");
  }, [props.mobile]);

  const maskedMobile = useMemo(() => {
    const tail = String(mobile || "").slice(-4);
    return tail ? `xxxxxx${tail}` : "your registered mobile number";
  }, [mobile]);

  return (
    <div className="pg-otp-modal">
      <div className="pg-otp-shell">
        <div className="pg-otp-hero">
          <div className="pg-otp-badge">Secure Verification</div>
          <div className="pg-otp-title-row">
            <h1>Verify OTP</h1>
            <button
              type="button"
              className="pg-otp-close"
              onClick={props.close}
              aria-label="Close OTP modal"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
          <p className="pg-otp-subtitle">
            Enter the 6-digit code sent to {maskedMobile}.
          </p>
        </div>

        <div className="pg-otp-body">
          <label className="pg-otp-label">OTP Code</label>
          <div
            className={`pg-otp-input-wrap${IsshowPass ? " is-visible" : ""}`}
          >
            <MaskedInput
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              guide={false}
              showMask={false}
              type={IsshowPass ? "tel" : "password"}
              className="pg-otp-input"
              placeholder="Enter OTP"
              max="6"
              maxLength="6"
              name="OTP"
              value={otpValue}
              onChange={(e) => {
                setOtpValue(e.target.value);
                props.handle?.(e);
              }}
              autoComplete="one-time-code"
            />
            <button
              type="button"
              className="pg-otp-visibility"
              onClick={() => setIsShow((prev) => !prev)}
              aria-label={IsshowPass ? "Hide OTP" : "Show OTP"}
            >
              <i className={IsshowPass ? "fas fa-eye" : "fas fa-eye-slash"} />
            </button>
          </div>

          <div className="pg-otp-meta">
            <div className="pg-otp-meta-item">
              <span className="pg-otp-meta-label">Code expires in</span>
              <strong>
                {String(minutes).padStart(2, "0")}:
                {String(seconds).padStart(2, "0")}
              </strong>
            </div>
            <div className="pg-otp-meta-item align-right">
              <span className="pg-otp-meta-label">
                Didn&apos;t receive the code?
              </span>
              <span className="pg-otp-resend-hint">
                Please wait for the timer to end, then request a fresh OTP.
              </span>
            </div>
          </div>

          <div className="pg-otp-meta-item pg-otp-meta-item--full">
            <span className="pg-otp-meta-label">Enter all 6 digits to continue</span>
          </div>

          <button
            className="pg-otp-submit"
            type="button"
            id="confirmOTP"
            value="Confirm"
            onClick={props.submit}
            disabled={isSubmitting || otpValue.length !== 6}
            aria-busy={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Verifying
                <span className="pg-otp-spinner" aria-hidden="true" />
              </>
            ) : (
              <>
                Verify & Continue
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.3 3.7L13.1 7.5H1V8.5H13.1L9.3 12.3L10 13L15 8L10 3L9.3 3.7Z"
                    fill="currentColor"
                  />
                </svg>
              </>
            )}
          </button>

          <div className="pg-otp-footnote">
            The OTP is tied to your policy proposal and will be validated
            instantly after submission.
          </div>
          <OTPTimer OTPMin={2} OTPSec={59} SendOTP={props.submit} />
        </div>
      </div>
    </div>
  );
};

export default OtpPopup;
